export enum RouteNames {
  InferenceMonitoring = 'InferenceMonitoring',
  Monitoring = 'Monitoring',
}
